<ion-header>
  <section #gridRef class="grid-wrapper background-background border-border">
    <div class="grid-container">
      <div class="grid-color-legend">
        <ng-container *ngTemplateOutlet="colorsRef"></ng-container>
      </div>

      <div class="grid-datepicker">
        <div class="sort">
          <div class="sort-dropdown">
            <frontend-dropdown-plain
              elementId="dayGridSort"
              placeholder="Sort"
              customClass="text-nowrap"
              [items]="sort"
              [(ngModel)]="sortValue"
              (ngModelChange)="changeSort(sortValue)"
              [customName]="sortItemName"
            ></frontend-dropdown-plain>
          </div>

          <div class="grid-color-legend-mobile">
            <ng-container *ngTemplateOutlet="colorsRef"></ng-container>
          </div>
        </div>

        <div class="cal-and-stuff d-flex">
          <div class="mr-1">
            <button class="btn btn-success user-select-none" (click)="changeDateToToday()">Today</button>
          </div>

          <div class="d-flex">
            <div class="ml-1 mr-1">
              <button class="btn btn-light user-select-none" (click)="selectPreviousDay()">
                <tr-icon [icon]="icon.arrowLeft" [size]="iconSize.small"></tr-icon>
              </button>
            </div>

            <div class="input-group datepicker-box background-background">
              <div>
                <button class="btn btn-info btn-light no-round-right" (click)="datepicker.toggle()">
                  <tr-icon [icon]="icon.date" [size]="iconSize.medium"></tr-icon>
                </button>
              </div>
              <input
                id="reservation-date-input"
                type="text"
                name="date"
                class="form-control no-round-left date-input user-select-none"
                placeholder="Select date"
                autocomplete="off"
                ngbDatepicker
                container="body"
                [minDate]="minDate"
                [weekdays]="true"
                [firstDayOfWeek]="7"
                #datepicker="ngbDatepicker"
                [(ngModel)]="reservationGridDateFilter"
                (ngModelChange)="changeDateForGrid()"
                #partyDate="ngModel"
                (click)="datepicker.toggle()"
              />
            </div>

            <div class="ml-1">
              <button class="btn btn-light user-select-none" (click)="selectNextDay()">
                <tr-icon [icon]="icon.arrowRight" [size]="iconSize.small"></tr-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</ion-header>

<ion-content [style.height]="'calc(100% - ' + gridRef.offsetHeight + 'px)'" [forceOverscroll]="false">
  <div class="grid-content">
    <full-calendar #calendar *ngIf="showDayGrid && !isLoading" [options]="calendarOptions">
    </full-calendar>

    <div *ngIf="!showDayGrid && !isLoading" class="col-12">
      <h4>Closed</h4>
    </div>

    <div *ngIf="isLoading" class="loader-section">
      <tr-loader [isSpinner]="true" [scale]="3"></tr-loader>
    </div>
  </div>
</ion-content>

<ng-template #colorsRef>
  <div class="daygrid-colors">
    <div class="pl-1 mr-2 dg-legend-item" *ngIf="legends.served">
      <span class="dg-legend-color dg-served"></span>
      <span class="dg-legend-text text-nowrap">- Served</span>
    </div>

    <div class="pl-1 mr-2 dg-legend-item" *ngIf="legends.checkIn">
      <span class="dg-legend-color dg-check-in"></span>
      <span class="dg-legend-text text-nowrap">- Checked in</span>
    </div>

    <div class="pl-1 mr-2 dg-legend-item" *ngIf="legends.notServed">
      <span class="dg-legend-color dg-not-served"></span>
      <span class="dg-legend-text text-nowrap">- Booked</span>
    </div>

    <div class="pl-1 mr-2 dg-legend-item" *ngIf="legends.notChecked">
      <span class="dg-legend-color dg-not-checked"></span>
      <span class="dg-legend-text text-nowrap">- Overdue</span>
    </div>
  </div>
</ng-template>
